import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75e1dac3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-red-pack" }
const _hoisted_2 = { class: "create-container" }
const _hoisted_3 = { class: "create-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Successful. View on", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "f(x)Wallet Homepage > NFT ASSETS", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_greeting_card = _resolveComponent("greeting-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_greeting_card, {
        img: require('@/assets/images/missionwagmiIcon/web_success.jpg')
      }, null, 8, ["img"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h4", null, "You Claimed: " + _toDisplayString(_ctx.butQuantity), 1),
      _hoisted_4,
      _hoisted_5
    ])
  ]))
}